import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8314a2b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-sales-buying-history-page" }

import { computed, onMounted } from 'vue'
import { ElNotification } from 'element-plus'
import useClipboard from 'vue-clipboard3'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import { usePermission } from '@/hooks/usePermission'
import {
  afterSalesBuyingHistorySearchItems,
  afterSalesBuyingHistoryTableColumns
} from './after-sales-buying-history.config'
import { fetchAfterSalesBuyingHistoryPage } from './after-sales-buying-history.service'
import type {
  AfterSalesBuyingHistoryFilters,
  AfterSalesBuyingHistoryRecord
} from './after-sales-buying-history.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyingHistory',
  setup(__props) {

const canList = usePermission('afterSalesLiveQuanzi', 'list')
const { toClipboard } = useClipboard()

function createFilters(): AfterSalesBuyingHistoryFilters {
  return {
    productName: '',
    customerName: '',
    nickname: '',
    unionid: '',
    channelName: '',
    isSigned: '',
    channelCode: '',
    status: '',
    isRefund: '',
    payTime: undefined
  }
}

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  refresh
} = usePagedCrud({
  createFilters,
  fetchPage: fetchAfterSalesBuyingHistoryPage
})

const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

function runQuery(action: () => Promise<boolean>) {
  return canList ? action() : Promise.resolve(false)
}

async function copyContractLink(row: AfterSalesBuyingHistoryRecord) {
  if (!row.signUrl) {
    ElNotification({
      title: '提示',
      message: '请联系合规提供合同链接',
      type: 'error'
    })
    return
  }

  try {
    await toClipboard(row.signUrl)
    ElNotification({
      title: '复制成功',
      message: '快去黏贴给客户吧',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      message: '请等一会，复制',
      type: 'error'
    })
  }
}

onMounted(() => runQuery(load))

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: _unref(afterSalesBuyingHistorySearchItems),
      loading: _unref(loading),
      onSearch: _cache[0] || (_cache[0] = ($event: any) => (runQuery(_unref(search)))),
      onReset: _cache[1] || (_cache[1] = ($event: any) => (runQuery(_unref(reset))))
    }, null, 8, ["model", "items", "loading"]),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      columns: _unref(afterSalesBuyingHistoryTableColumns),
      onPageChange: _cache[2] || (_cache[2] = ($event: any) => (runQuery(() => _unref(changePage)($event)))),
      onPageSizeChange: _cache[3] || (_cache[3] = ($event: any) => (runQuery(() => _unref(changePageSize)($event)))),
      onRetry: _cache[4] || (_cache[4] = ($event: any) => (runQuery(_unref(refresh))))
    }, {
      title: _withCtx(() => [
        _createTextVNode("直播间购买记录")
      ]),
      signUrl: _withCtx(({ row }) => [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "mini",
          onClick: ($event: any) => (copyContractLink(row))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 点击复制 ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "columns"])
  ]))
}
}

})